import { DashboardShell } from "./DashboardShell";
import { MetricCard } from "./MetricCard";
import { ChartCard } from "./ChartCard";
import { ActivityPanel } from "./ActivityPanel";
import { assetPreview } from "@/data/dashboardPreview.data";
import { DashboardContent } from "./DashboardContent";

interface Props {
    accent: string;
}

export function AssetManagementDashboard({
    accent,
}: Props) {
    const preview = assetPreview;

    return (
        <DashboardShell
            accent={accent}
            title="Enterprise Asset Management"
            subtitle="Asset lifecycle, maintenance and compliance dashboard"
            sidebar={[
                "Dashboard",
                "Assets",
                "Work Orders",
                "Preventive Maintenance",
                "Calibration",
                "Inventory",
                "Engineers",
                "Reports",
            ]}
        >
            <DashboardContent

                accent={accent}

                preview={assetPreview}

                activityTitle="Maintenance Activity"

            />

            <div className="mt-6 grid gap-3 md:grid-cols-4">

                {
                    [
                        {
                            label:"Asset Utilization",
                            value:"94%",
                            trend:"+3%"
                        },
                        {
                            label:"PM Compliance",
                            value:"98%",
                            trend:"+2%"
                        },
                        {
                            label:"MTR",
                            value:"3 hrs",
                            trend:"-12%"
                        },
                        {
                            label:"Asset Availability",
                            value:"99%",
                            trend:"+1%"
                        },
                    ].map((metric) => (

                        <MetricCard
                            key={metric.label}
                            accent={accent}
                            label={metric.label}
                            value={metric.value}
                            trend={metric.trend}
                        />

                    ))
                }

            </div>
            
            {/* <div className="grid gap-6"> */}

                {/* ==========================================================
                    Executive KPIs
                =========================================================== */}

                {/* <div className="grid gap-5 md:grid-cols-4">

                    {
                        preview.metrics.map((metric) => (

                            <MetricCard
                                key={metric.label}
                                accent={accent}
                                label={metric.label}
                                value={metric.value}
                                trend={metric.trend}
                            />

                        ))
                    }
                </div> */}

                {/* ==========================================================
                    Lifecycle Analytics
                =========================================================== */}

                {/* <div className="grid gap-6 lg:grid-cols-[2fr_1fr]">

                    <ChartCard
                        accent={accent}
                        title={preview.chart.title}
                        values={preview.chart.values}
                    />

                    <ActivityPanel
                        accent={accent}
                        title="Maintenance Activity"
                        items={preview.activities ?? []}
                    />

                </div> */}
                {/* ==========================================================
                    Maintenance Operations
                =========================================================== */}

                {/* <div className="grid gap-6 lg:grid-cols-3">

                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Preventive Maintenance
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                {
                                    asset: "Air Handling Unit",
                                    due: "Today",
                                },
                                {
                                    asset: "Generator DG-07",
                                    due: "Tomorrow",
                                },
                                {
                                    asset: "UPS System",
                                    due: "2 Days",
                                },
                                {
                                    asset: "Chiller Plant",
                                    due: "4 Days",
                                },
                            ].map((row) => (

                                <div
                                    key={row.asset}
                                    className="flex items-center justify-between rounded-xl border border-border px-4 py-3"
                                >

                                    <div>

                                        <p className="font-medium">
                                            {row.asset}
                                        </p>

                                        <p className="text-xs text-muted-foreground">
                                            Scheduled PM
                                        </p>

                                    </div>

                                    <span
                                        className="rounded-full px-3 py-1 text-xs font-semibold"
                                        style={{
                                            background: `${accent}15`,
                                            color: accent,
                                        }}
                                    >
                                        {row.due}
                                    </span>

                                </div>

                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Corrective Work Orders
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                {
                                    wo: "WO-24051",
                                    priority: "Critical",
                                },
                                {
                                    wo: "WO-24052",
                                    priority: "High",
                                },
                                {
                                    wo: "WO-24053",
                                    priority: "Medium",
                                },
                                {
                                    wo: "WO-24054",
                                    priority: "Low",
                                },
                            ].map((wo) => (

                                <div
                                    key={wo.wo}
                                    className="flex items-center justify-between rounded-xl border border-border px-4 py-3"
                                >

                                    <div>

                                        <p className="font-medium">
                                            {wo.wo}
                                        </p>

                                        <p className="text-xs text-muted-foreground">
                                            Breakdown Maintenance
                                        </p>

                                    </div>

                                    <span
                                        className={`rounded-full px-3 py-1 text-xs font-semibold ${
                                            wo.priority === "Critical"
                                                ? "bg-red-100 text-red-700"
                                                : wo.priority === "High"
                                                ? "bg-orange-100 text-orange-700"
                                                : wo.priority === "Medium"
                                                ? "bg-yellow-100 text-yellow-700"
                                                : "bg-green-100 text-green-700"
                                        }`}
                                    >
                                        {wo.priority}
                                    </span>

                                </div>

                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Asset Verification
                        </h3>

                        <div className="mt-5 space-y-5">

                            {[
                                {
                                    label: "Tagged",
                                    value: 96,
                                },
                                {
                                    label: "Verified",
                                    value: 91,
                                },
                                {
                                    label: "Audited",
                                    value: 84,
                                },
                                {
                                    label: "Closed",
                                    value: 79,
                                },
                            ].map((item) => (

                                <div key={item.label}>

                                    <div className="flex justify-between text-sm">

                                        <span>{item.label}</span>

                                        <span>{item.value}%</span>

                                    </div>

                                    <div className="mt-2 h-2 rounded-full bg-muted">

                                        <div
                                            className="h-full rounded-full"
                                            style={{
                                                width: `${item.value}%`,
                                                background: accent,
                                            }}
                                        />

                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                </div> */}
                {/* ==========================================================
                    Asset Tracking
                =========================================================== */}

                {/* <div className="grid gap-6 lg:grid-cols-3">

                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            QR / Barcode Tagging
                        </h3>

                        <div className="mt-5 space-y-5">

                            {[
                                {
                                    label: "QR Tagged",
                                    value: 98,
                                },
                                {
                                    label: "Barcode Tagged",
                                    value: 94,
                                },
                                {
                                    label: "RFID Tagged",
                                    value: 71,
                                },
                                {
                                    label: "Verified",
                                    value: 89,
                                },
                            ].map((item) => (

                                <div key={item.label}>

                                    <div className="flex justify-between text-sm">

                                        <span>{item.label}</span>

                                        <span>{item.value}%</span>

                                    </div>

                                    <div className="mt-2 h-2 rounded-full bg-muted">

                                        <div
                                            className="h-full rounded-full"
                                            style={{
                                                width: `${item.value}%`,
                                                background: accent,
                                            }}
                                        />

                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Warranty & AMC
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                {
                                    asset: "MRI Machine",
                                    status: "Warranty",
                                },
                                {
                                    asset: "Diesel Generator",
                                    status: "AMC",
                                },
                                {
                                    asset: "UPS System",
                                    status: "Expiring",
                                },
                                {
                                    asset: "Chiller Unit",
                                    status: "Expired",
                                },
                            ].map((row) => (

                                <div
                                    key={row.asset}
                                    className="flex items-center justify-between rounded-xl border border-border px-4 py-3"
                                >

                                    <div>

                                        <p className="font-medium">
                                            {row.asset}
                                        </p>

                                        <p className="text-xs text-muted-foreground">
                                            Coverage Status
                                        </p>

                                    </div>

                                    <span
                                        className={`rounded-full px-3 py-1 text-xs font-semibold ${
                                            row.status === "Warranty"
                                                ? "bg-green-100 text-green-700"
                                                : row.status === "AMC"
                                                ? "bg-blue-100 text-blue-700"
                                                : row.status === "Expiring"
                                                ? "bg-yellow-100 text-yellow-700"
                                                : "bg-red-100 text-red-700"
                                        }`}
                                    >
                                        {row.status}
                                    </span>

                                </div>

                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Calibration Due
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                "Pressure Gauge PG-101",
                                "Flow Meter FM-212",
                                "Temperature Sensor TS-41",
                                "Weighing Balance WB-17",
                            ].map((asset) => (

                                <div
                                    key={asset}
                                    className="rounded-xl border border-border p-4"
                                >

                                    <p className="font-medium">
                                        {asset}
                                    </p>

                                    <p className="mt-1 text-xs text-muted-foreground">
                                        Due within 7 days
                                    </p>

                                </div>

                            ))}

                        </div>

                    </div>

                </div> */}
                {/* ==========================================================
                    Field Engineers
                =========================================================== */}

                {/* <div className="grid gap-6 lg:grid-cols-[2fr_1fr]">

                    <ChartCard
                        accent={accent}
                        title="Engineer Workload"
                        values={[
                            45,
                            56,
                            62,
                            71,
                            79,
                            84,
                            68,
                        ]}
                    />

                    <ActivityPanel
                        accent={accent}
                        title="Critical Alerts"
                        items={[
                            {
                                title: "Generator Offline",
                                description:
                                    "DG-07 requires immediate engineer assignment.",
                                status: "warning",
                            },
                            {
                                title: "Calibration Overdue",
                                description:
                                    "12 critical laboratory instruments overdue.",
                                status: "warning",
                            },
                            {
                                title: "Asset Transfer Pending",
                                description:
                                    "18 department transfer requests awaiting approval.",
                                status: "info",
                            },
                            {
                                title: "PM Compliance Achieved",
                                description:
                                    "Monthly PM completion crossed 98%.",
                                status: "success",
                            },
                        ]}
                    />

                </div> */}
                {/* <div className="grid gap-6 lg:grid-cols-2">

                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            AI Maintenance Advisor
                        </h3>

                        <div className="mt-5 space-y-4">

                            {[
                                "Generator DG-07 shows increasing vibration trend. Recommend predictive inspection.",
                                "AHU-04 energy consumption increased 16% over previous month.",
                                "MRI cooling system approaching preventive maintenance threshold.",
                                "UPS battery health indicates replacement within next 30 days.",
                            ].map((tip) => (

                                <div
                                    key={tip}
                                    className="rounded-xl border border-border p-4"
                                >

                                    <p className="text-sm leading-relaxed">
                                        {tip}
                                    </p>

                                </div>

                            ))}

                        </div>

                    </div>
                    <div className="rounded-2xl border border-border bg-card p-5">

                        <h3 className="text-sm font-semibold">
                            Department Distribution
                        </h3>

                        <div className="mt-5 space-y-5">

                            {[
                                {
                                    department: "Engineering",
                                    value: 92,
                                },
                                {
                                    department: "Production",
                                    value: 84,
                                },
                                {
                                    department: "Utilities",
                                    value: 73,
                                },
                                {
                                    department: "Laboratory",
                                    value: 66,
                                },
                            ].map((dept) => (

                                <div key={dept.department}>

                                    <div className="flex justify-between text-sm">

                                        <span>{dept.department}</span>

                                        <span>{dept.value}%</span>

                                    </div>

                                    <div className="mt-2 h-2 rounded-full bg-muted">

                                        <div
                                            className="h-full rounded-full"
                                            style={{
                                                width: `${dept.value}%`,
                                                background: accent,
                                            }}
                                        />

                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                </div> */}

            {/* </div> */}

        </DashboardShell>

    );
}